import {
    Box,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import type { IInactiveEpisodeCategory } from '../../../../common/api/employment/getInactiveEpisodeCategoryResult';
import { translateKey } from '../../../translate';
import { formatRight } from '../../../utils/formatRight';
import { NullableFormattedDate } from '../../elements/NullableFormattedDate';

interface IPersonalSettingsInactiveCarePathProps {
    inactiveEpisodeCategory: IInactiveEpisodeCategory;
}

export function PersonalSettingsInactiveCarePath(props: IPersonalSettingsInactiveCarePathProps) {
    function getServiceRights(serviceGroupName: string) {
        return props.inactiveEpisodeCategory.serviceRights.filter(
            (serviceRight) => serviceRight.serviceGroup.name === serviceGroupName
        );
    }

    return (
        <>
            {props.inactiveEpisodeCategory.episodeCategoryRights.length > 0 && (
                <Card>
                    <Card.Header
                        title={translateKey('addCarePathSectionTitles.serviceReaderSettings')}
                        tooltipContent={translateKey('readers.explanation')}
                    />
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableHeader>
                                        <Box pl={4}>{translateKey('common.startingDate')}</Box>
                                    </TableHeader>
                                    <TableHeader>{translateKey('common.endDate')}</TableHeader>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.inactiveEpisodeCategory.episodeCategoryRights.map((episodeCategoryRight) => {
                                    return (
                                        <TableRow key={episodeCategoryRight.id}>
                                            <TableCell>
                                                <Box pl={4}>
                                                    <NullableFormattedDate value={episodeCategoryRight.startDate} />
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <NullableFormattedDate value={episodeCategoryRight.endDate} />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            )}

            {props.inactiveEpisodeCategory.serviceGroupNames.map((serviceGroupName) => (
                <Card key={serviceGroupName}>
                    <Card.Header title={serviceGroupName} />
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableHeader style={{ paddingLeft: '16px' }}>
                                        {translateKey('service.service')}
                                    </TableHeader>
                                    <TableHeader style={{ width: '25%' }}>{translateKey('service.rights')}</TableHeader>
                                    <TableHeader style={{ width: '25%' }}>
                                        {translateKey('common.startingDate')}
                                    </TableHeader>
                                    <TableHeader style={{ width: '25%' }}>{translateKey('common.endDate')}</TableHeader>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getServiceRights(serviceGroupName).map((serviceRight) => {
                                    return (
                                        <TableRow key={serviceRight.id}>
                                            <TableCell style={{ paddingLeft: '32px' }}>
                                                {serviceRight.service.name}
                                            </TableCell>
                                            <TableCell>{formatRight(serviceRight, 'showServiceType')}</TableCell>
                                            <TableCell>
                                                <NullableFormattedDate value={serviceRight.startDate} />
                                            </TableCell>
                                            <TableCell>
                                                <NullableFormattedDate value={serviceRight.endDate} />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            ))}
        </>
    );
}
